'use strict';

(function () {

  var FitmentGuard = {
    _pendingVariantId: null,
    _pendingCallback: null,

    check: function (variantId, resumeCallback, productHandle) {
      console.log('[FitmentGuard] check called - variantId:', variantId, 'productHandle:', productHandle, 'YMM_MANDATORY_HANDLES:', window.YMM_MANDATORY_HANDLES);
      // Not a mandatory fitment product — pass through
      if (!FitmentGuard._isMandatory(variantId, productHandle)) {
        console.log('[FitmentGuard] Not mandatory, passing through');
        return true;
      }

      // Engine errored — fail open (never block all purchases)
      if (window.YMMEngine && window.YMMEngine.state === 'error') return true;

      // Engine still loading — queue and defer
      if (!window.YMMEngine || window.YMMEngine.state !== 'ready') {
        FitmentGuard._pendingVariantId = variantId;
        FitmentGuard._pendingCallback = resumeCallback;
        document.addEventListener('ymm:ready', function onReady() {
          document.removeEventListener('ymm:ready', onReady);
          FitmentGuard.check(variantId, resumeCallback);
        }, { once: true });
        return false;
      }

      // No vehicle selected — open drawer
      var vehicle = window.FitmentStorage ? window.FitmentStorage.getVehicle() : null;
      if (!vehicle) {
        FitmentGuard._pendingVariantId = variantId;
        FitmentGuard._pendingCallback = resumeCallback;
        FitmentGuard.openDrawer();
        return false;
      }

      // Verify line item properties are actually populated (belt-and-suspenders)
      if (!FitmentGuard._hasLineItemProperties()) {
        FitmentGuard._pendingVariantId = variantId;
        FitmentGuard._pendingCallback = resumeCallback;
        FitmentGuard.openDrawer();
        return false;
      }

      // Lookup fitment for this vehicle
      var fitment = window.YMMEngine.lookup(vehicle.year, vehicle.make, vehicle.model);

      // No fitment data for vehicle — fail open
      if (!fitment) return true;

      // All other cases — allow through (review banner shown by applyVariantLock on PDP)
      return true;
    },

    _isMandatory: function (variantId, productHandle) {
      if (!window.YMM_MANDATORY_HANDLES) return false;

      // Check by product handle first (for small cards)
      if (productHandle && window.YMM_MANDATORY_HANDLES.indexOf(productHandle) !== -1) {
        return true;
      }

      // Check by variant ID mapping (for PDP)
      if (!window.YMM_PRODUCT_VARIANT_MAP) return false;
      var handle = window.YMM_PRODUCT_VARIANT_MAP[variantId];
      if (!handle) return false;
      return window.YMM_MANDATORY_HANDLES.indexOf(handle) !== -1;
    },

    _getVariantSku: function (variantId) {
      var el = document.querySelector('variant-selects [type="application/json"]');
      if (!el) return null;
      try {
        var variants = JSON.parse(el.textContent);
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) return variants[i].sku || null;
        }
        return null;
      } catch (e) { return null; }
    },

    _hasLineItemProperties: function () {
      var vehicleEl = document.getElementById('fitment-prop-vehicle');
      var yearEl    = document.getElementById('fitment-prop-year');
      if (!vehicleEl || !yearEl) return true; // inputs missing — can't verify, fail open
      return vehicleEl.value.trim() !== '' && yearEl.value.trim() !== '';
    },

    openDrawer: function () {
      var drawer = document.getElementById('YMM-Drawer');
      if (!drawer) return;
      document.body.classList.add('open-cc');
      drawer.classList.add('active');
      drawer.focus();
      FitmentGuard._trapFocus(drawer);
      document.dispatchEvent(new CustomEvent('ymm-drawer:open'));
    },

    closeDrawer: function () {
      var drawer = document.getElementById('YMM-Drawer');
      if (!drawer) return;
      drawer.classList.remove('active');
      document.body.classList.remove('open-cc');
      document.dispatchEvent(new CustomEvent('ymm-drawer:close'));
    },

    _trapFocus: function (drawer) {
      var focusable = drawer.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];

      function onTab(e) {
        if (e.key !== 'Tab') return;
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
        }
      }

      function cleanup() {
        drawer.removeEventListener('keydown', onTab);
        document.removeEventListener('ymm-drawer:close', cleanup);
      }

      drawer.addEventListener('keydown', onTab);
      document.addEventListener('ymm-drawer:close', cleanup);

      document.addEventListener('keydown', function onEsc(e) {
        if (e.key === 'Escape' && drawer.classList.contains('active')) {
          document.removeEventListener('keydown', onEsc);
          FitmentGuard.closeDrawer();
          FitmentGuard._clearPending();
        }
      });
    },

    _clearPending: function () {
      FitmentGuard._pendingVariantId = null;
      FitmentGuard._pendingCallback = null;
    },

    _resume: function () {
      if (FitmentGuard._pendingCallback) {
        var cb = FitmentGuard._pendingCallback;
        FitmentGuard._clearPending();
        cb();
      }
    }
  };

  // Resume ATC after vehicle is confirmed
  document.addEventListener('ymm:confirmed', function () {
    FitmentGuard.closeDrawer();
    FitmentGuard._resume();
  });

  // Close button click
  document.addEventListener('click', function (e) {
    if (e.target.closest('.ymm-drawer__close')) {
      FitmentGuard.closeDrawer();
      FitmentGuard._clearPending();
    }
    // Click-capture overlay close
    if (e.target.matches('.click-capture')) {
      var drawer = document.getElementById('YMM-Drawer');
      if (drawer && drawer.classList.contains('active')) {
        FitmentGuard.closeDrawer();
        FitmentGuard._clearPending();
      }
    }
  });

  window.FitmentGuard = FitmentGuard;

})();
